import { useSelector } from 'react-redux';
import { selectSchema } from '../store/selectors';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import CWTForm from './CWTForm';
import EmptyStateNew from '../../../components/empty-state/EmptyStateNew';
import ErrorBoundary from '../../../ErrorBoundary';

type SchemaContainerProps = {
    templateName: string;
};

function SchemaContainer({ templateName }: SchemaContainerProps): JSX.Element {
    const schema = useSelector(selectSchema);
    return (
        <div className="h-full [&>div]:mt-0">
            <ErrorBoundary>
                {schema ? (
                    <CWTForm templateName={templateName} />
                ) : (
                    <div className="self-center mx-auto -mt-32">
                        <EmptyStateNew
                            title="No custom worksheet template schema found"
                            helpText="We were unable to load the schema for this custom worksheet template. Please try refreshing the page."
                            icon={<ExclamationTriangleIcon />}
                        />
                    </div>
                )}
            </ErrorBoundary>
        </div>
    );
}

export default SchemaContainer;
